module.exports = __webpack_public_path__ + "img/minus_btn.93763a6c.png";